import * as React from 'react';
import Page from '../Page';
import ReportAssignmentCore from '../core/ReportAssignmentCore';
import { TaxonomyTypeEnum } from '../../redux/TaxonomyVersionSlice';




const CourtReporting939Assignments = (props: any) => {
    return (
        <React.Fragment>
            <Page>
                <ReportAssignmentCore taxonomyType={TaxonomyTypeEnum.COURT_REPORTING_939} />
            </Page>
        </React.Fragment>
    );
}

export default CourtReporting939Assignments;